import { render, staticRenderFns } from "./DownloadAppPhoneInput.vue?vue&type=template&id=59920160&scoped=true&lang=pug&"
import script from "./DownloadAppPhoneInput.vue?vue&type=script&lang=ts&"
export * from "./DownloadAppPhoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadAppPhoneInput.vue?vue&type=style&index=0&id=59920160&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59920160",
  null
  
)

export default component.exports